import {
  SupplyFixContractStateTypes,
  SupplyFixContractActionTypes,
} from "./SupplyFixContract.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SupplyFixContractStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SupplyFixContractReducer = (
  state: SupplyFixContractStateTypes = INITIAL_STATE,
  action: any
): SupplyFixContractStateTypes => {
  switch (action.type) {
    case SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SupplyFixContractReducer;
